import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LgvModel } from '../../data-models/longevity.model';
import { ActivatedRoute } from '@angular/router';

import { ROUTE_ANIMATIONS_ELEMENTS, NotificationService, LgvAPIService, LgvTSHelper } from '../../core/core.module';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'lgv-numeric-input',
    templateUrl: './numeric-input.component.html',
    styleUrls: ['./numeric-input.component.scss']
})
export class NumericInputComponent implements OnInit {
    NumValValue = 0;
    @Output() NumValChange = new EventEmitter();
    @Output() ChangeWithFocus = new EventEmitter();
    @Output() PropChanged = new EventEmitter();

    @Input()
    get NumVal() {
        return this.NumValValue;
    }

    set NumVal(newVal) {
        let prevVal = this.NumValValue;
        if (prevVal != newVal) {
            this.NumValValue = newVal;
            this.FormatDisplayFromValue();
            this.NumValChange.emit(this.NumValValue);// Actually updates the model
            //this.PropChanged.emit(new PropertyChangedEvent(this.BindProp, prevVal, newVal, this.HaveFocus)); // Helper Event
        }
    }

    @Input() Class: string;
    @Input() Decimals: number;
    @Input() Prefix: string;
    @Input() ShowPct: boolean;
    @Input() HideDecimalsForEditMode: boolean = false;
    @Input() IsReadOnly: boolean = false;
    @Input() IsRequired: boolean = false;
    @Input() BindProp: string;
    @Input() NullToZero: boolean = true;
    @Input() MinValue: number;
    @Input() MaxValue: number;

    DispValue: string;
    LastFocus: Date;
    HaveFocus: boolean = false;

    get IsReadOnlyClass(): boolean { return this.Class != null && this.Class.indexOf("ReadOnly") != -1; }
    get TabIndex(): number { return this.IsReadOnly ? -1 : 0; }
    get IsValid(): boolean {
        return (!this.IsRequired
            || (this.NumVal != undefined && this.NumVal != 0)
            || (this.NullToZero == false && this.NumVal == 0)
        )
            && (this.MinValue == null || this.NumVal === undefined || this.NumVal >= this.MinValue)
            && (this.MaxValue == null || this.NumVal === undefined || this.NumVal <= this.MaxValue);
    }

    constructor() {
    }

    ngOnInit() {
        this.FormatDisplayFromValue();
    }

    OnFocusIn(event: any) {
        this.HaveFocus = true;
        this.FormatDisplayForEdit();

        setTimeout(() => {
            if (this.HaveFocus) {
                event.target.select();
            }
            //else {
            //    console.log('********** Skipping Focus Callback!!!!!! ********** - ' + this.DispValue + '  |  ' + this.HaveFocus);
            //}
        }, 10);

    }

    OnFocusOut(event: any) {
        this.UpdateValueFromDisplay();
        this.FormatDisplayFromValue();
        this.HaveFocus = false;
    }

    UpdateValueFromDisplay() {

        if (!this.NullToZero && (this.DispValue == undefined || this.DispValue == '')) {
            this.DispValue = '';
            this.NumVal = null;
            return;
        }

        if (this.DispValue == undefined || this.DispValue == '') {
            this.DispValue = "0";
        }
        this.NumVal = LgvTSHelper.stringToNumber(this.DispValue);
    }

    FormatDisplayFromValue() {
        if (this.NumVal == null || this.NumVal == undefined) {
            this.DispValue = '';
            return;
        }

        let tempNum: string = '0';

        let safeNum: number = typeof this.NumVal === 'number' ? this.NumVal : LgvTSHelper.stringToNumber(this.NumVal);

        if (safeNum != null) {
            if (this.Decimals != null) {
                tempNum = safeNum.toFixed(this.Decimals);
            }
            else {
                tempNum = safeNum.toString();
            }
        }

        let tempDisp = LgvTSHelper.numberWithCommas(tempNum);

        if (this.Prefix != null) {
            tempDisp = this.Prefix + tempDisp;
        }

        if (this.ShowPct != null && this.ShowPct) {
            tempDisp += '%';
        }


        if (this.NumVal < 0) {
            tempDisp = '(' + tempDisp.replace('-', '') + ')';
        }

        this.DispValue = tempDisp;
    }

    FormatDisplayForEdit() {
        try {
            if (this.NumVal == null || this.NumVal == undefined) {
                this.DispValue = '';
                return;
            }

            let safeNum: number = typeof this.NumVal === 'number' ? this.NumVal : LgvTSHelper.stringToNumber(this.NumVal);

            if (this.HideDecimalsForEditMode) {
                //console.log('Setting precision to Zero');
                this.DispValue = safeNum.toFixed(0);
            }
            else {
                //console.log('Setting precision to 2 or 3');
                this.DispValue = this.ShowPct ? safeNum.toFixed(3) : safeNum.toFixed(2);
            }
        }

        catch (ex) {
            console.log('Exception in FormatDisplayForEdit()  => NumVal: ' + this.NumVal + ' typeof => ' + typeof this.NumVal);
            console.log(ex);
        }
    }

}

